class AhaSlidesUploader {
  constructor(uploader, featureName) {
    this.uploader = uploader
    this.featureName = featureName
  }

  upload(files) {
    this.uploader.upload(files, this.featureName)
  }

  onUploadSuccess(result) {
    this.uploader.onUploadSuccess(result)
  }

  onUploadError(error) {
    this.uploader.onUploadError(error)
  }
}

export default AhaSlidesUploader
